
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { CrayonSubscriptionStatus } from 'enums/CrayonSubscriptionStatus';
import { Model, ModelProperty } from 'models/Model';


export class SubscriptionModel extends Model<SubscriptionModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'number', languageString: 'subscription.property.id', isHidden: true },
		{ name: 'name', type: 'string', languageString: 'subscription.property.name' },
		{ name: 'quantity', type: 'number', languageString: 'subscription.property.quantity' },
		{ name: 'status', type: 'CrayonSubscriptionStatus', languageString: 'subscription.property.status' },
		{ name: 'subscriptionId', type: 'string', languageString: 'subscription.property.subscriptionId' }
	];
	[key: string]: any;
	
	public id: number;
	public name: string;
	public quantity: number;
	public status: CrayonSubscriptionStatus;
	public subscriptionId: string;
    
	constructor(){
		super();
		this.id = 0;
		this.name = '';
		this.quantity = 0;
		this.status = 0;
		this.subscriptionId = '';
		
	}
	getProperties(){
		return SubscriptionModel.classProperties;
	}
}

